/* istanbul ignore file */

import type { SVGProps } from 'react';
import { useTheme } from 'styled-components';

import type theme from '@shared/theme';

type Props = SVGProps<SVGSVGElement> & {
    fillColor?: keyof typeof theme.colors;
    strokeColor?: keyof typeof theme.colors;
    strokeWidth?: number;
};

export default function ClientIcon({
    fillColor,
    strokeColor,
    strokeWidth,
    ...props
}: Props) {
    const theme = useTheme();

    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            role="img"
        >
            <circle
                cx="20"
                cy="20"
                r="20"
                fill={fillColor ? theme.colors[fillColor] : '#F3F3F4'}
            />
            <path
                d="M27.62 27.62v-1.906a3.81 3.81 0 0 0-3.81-3.81h-7.62a3.81 3.81 0 0 0-3.809 3.81v1.905"
                stroke={strokeColor ? theme.colors[strokeColor] : '#282B43'}
                strokeWidth={strokeWidth ? strokeWidth : 2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20 18.095a3.81 3.81 0 1 0 0-7.619 3.81 3.81 0 0 0 0 7.62Z"
                stroke={strokeColor ? theme.colors[strokeColor] : '#282B43'}
                strokeWidth={strokeWidth ? strokeWidth : 2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
